window.DYNAMIC_TRANSLATIONS = {
  "id": {
    "Women's": "Wanita",
    "Men's": "Pria",
    "Girls": "Anak Perempuan",
    "Boys": "Anak Laki-Laki",
    "Baby & Toddler Outfits": "Pakaian Bayi & Balita",
    "Bodysuits": "Bodysuit",
    "Bolero Jackets": "Jaket Bolero",
    "Bomber Jackets": "Jaket Bomber",
    "Bras": "Bra",
    "Briefs": "Celana Dalam",
    "Cargo Pants": "Celana Kargo",
    "Dresses": "Gaun",
    "Hoodies": "Hoodie",
    "Jeans": "Jeans",
    "Joggers": "Celana Jogger",
    "Leggings": "Legging",
    "Neckties": "Dasi",
    "Overcoats": "Mantel",
    "Polos": "Polo",
    "Puffer Jackets": "Jaket Puffer",
    "Shirts": "Kemeja",
    "Short Trousers": "Celana Pendek",
    "Skirts": "Rok",
    "Skorts": "Rok Celana (Skort)",
    "Sweaters": "Sweater",
    "Sweatpants": "Celana Training",
    "Sweatshirts": "Sweater / Sweatshirt",
    "T-Shirts": "Kaos",
    "Tank Tops": "Tank Top",
    "Trench Coats": "Mantel Trench",
    "Trousers": "Celana Panjang",
    "Trunks": "Celana Renang",
    "Vests": "Rompi"
  }
};

// Filter values translation
(function () {
    const DEBUG = true; // set false to silence logs
    if(localStorage.getItem("selectedLocale") != "id") return; 
    const translationMap = window.DYNAMIC_TRANSLATIONS["id"];
    // Normalize map keys for case-insensitive matching
    const normalizedMap = {};
    Object.keys(translationMap).forEach(k => {
        normalizedMap[k.toLowerCase()] = translationMap[k];
    });

    function debug(...args) { if (DEBUG) console.log('[translateFilter]', ...args); }

    function cleanLabelText(text) {
        if (!text) return '';
        // trim and remove trailing counts like " (12)" or " - 12"
        return text
        .trim()
        .replace(/\s*\(\d+\)\s*$/, '')   // remove trailing (12)
        .replace(/\s*-\s*\d+\s*$/, '')   // remove trailing - 12
        .replace(/\s+$/, '')
        .trim();
    }

    function findTranslationFor(original) {
        if (!original) return null;
        const base = cleanLabelText(original);
        const low = base.toLowerCase();

        // direct match
        if (normalizedMap[low]) return normalizedMap[low];

        // startsWith match (handles "Women's - New")
        for (const keyLower in normalizedMap) {
        if (low.startsWith(keyLower)) return normalizedMap[keyLower];
        }

        return null;
    }

    function translateOnce() {
        // list of possible selectors used by Globo/theme
        const selectors = [
        '.gf-label',
        '.filter-item-label',
        '.gl-filter-option-label',
        '.gf-filter-option__label',
        '.filter-label', // theme generic
        ];

        const used = new Set();
        selectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
            // avoid duplicate processing if same element matches multiple selectors
            if (used.has(el)) return;
            used.add(el);

            const original = el.textContent;
            const base = cleanLabelText(original);
            const translated = findTranslationFor(base);
            if (translated) {
            if (el.textContent.trim() !== translated) {
                debug('Translating:', `"${original}" -> "${translated}"`, el);
                el.textContent = translated;
            }
            }
        });
        });
    }

    // debounce wrapper to avoid thrash
    let debounceTimer = null;
    function scheduleTranslate() {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
        translateOnce();
        debounceTimer = null;
        }, 120); // 120ms after DOM changes stop
    }

    // MutationObserver that calls scheduleTranslate
    const observer = new MutationObserver((mutations) => {
        // quick heuristic: only schedule if nodes added/changed
        let added = false;
        for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) { added = true; break; }
        if (m.type === 'characterData') { added = true; break; }
        }
        if (added) scheduleTranslate();
    });

    // Try to attach to the most specific container first
    const candidateSelectors = [
        '.gf-filter-contents',
        '.gf-filter-body',
        '.globo-filter-block',
        '.sidebar', // fallback
    ];

    function attachObserver() {
        for (const sel of candidateSelectors) {
        const node = document.querySelector(sel);
        if (node) {
            debug('Attaching observer to', sel, node);
            observer.observe(node, { childList: true, subtree: true, characterData: true });
            scheduleTranslate();
            return;
        }
        }

        // If none of the specific containers found, observe body (catch-all)
        debug('No specific filter container found; attaching observer to document.body');
        observer.observe(document.body, { childList: true, subtree: true, characterData: true });

        // also try to translate immediately in case elements already present
        scheduleTranslate();
    }

    // Start when DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attachObserver);
    } else {
        attachObserver();
    }

    // Expose a manual run + stop for debugging in console
    window.__translateFiltersRun = scheduleTranslate;
    window.__translateFiltersStop = () => {
        observer.disconnect();
        debug('Observer disconnected');
    };
})();